import { useState } from 'react'

const sections = [
  {
    title: 'Szkoły ponadgimnazjalne',
    links: [
      { label: 'Serwis maturzystów', href: 'http://matura.perspektywy.pl' },
      { label: 'Licea w Polsce', href: 'http://licea.perspektywy.pl' },
      { label: 'Technika w Polsce', href: 'http://technika.perspektywy.pl' },
      { label: 'Matura międzynarodowa', href: 'http://ib.perspektywy.pl' },
    ],
  },
  {
    title: 'Studia w Polsce i za granicą',
    links: [
      { label: 'Studia podyplomowe', href: 'http://podyplomowe.perspektywy.pl' },
      { label: 'Studia doktoranckie', href: 'http://doktoranckie.perspektywy.pl' },
      { label: 'Studia MBA', href: 'http://mba.perspektywy.pl' },
      { label: 'Uczelnie niepubliczne', href: 'http://niepubliczne.perspektywy.pl' },
      { label: 'Państwowe Wyższe Szkoły Zawodowe', href: 'http://pwsz.perspektywy.pl' },
    ],
  },
  {
    title: 'Rankingi',
    links: [
      { label: 'Ranking Studiów Inżynierskich 2019', href: 'http://engineering.perspektywy.pl/' },
      { label: 'Ranking Szkół Wyższych 2019', href: 'http://ranking.perspektywy.pl' },
      { label: 'Ranking MBA Perspektywy 2018', href: 'http://mba.perspektywy.pl' },
      { label: 'Ranking Liceów 2020', href: 'http://licea.perspektywy.pl' },
      { label: 'Ranking Liceów STEM 2016', href: 'http://rankingstem.perspektywy.pl' },
      { label: 'Ranking Techników 2020', href: 'http://technika.perspektywy.pl' },
      { label: 'Ranking Szkół Warszawskich 2016', href: 'http://rankingwarszawski.perspektywy.pl' },
    ],
  },
  {
    title: 'Perspektywy Press',
    external: true,
    links: [
      { label: 'Salon Maturzystów PERSPEKTYWY', href: 'http://www.salonmaturzystow.pl/' },
      { label: 'Międzynarodowy Salon Edukacyjny PERSPEKTYWY', href: 'http://www.salon.perspektywy.pl/' },
      { label: 'Oferta Reklamowa', href: 'http://www.perspektywy.pl/reklama' },
      { label: 'Prenumerata', href: 'http://prenumerata.perspektywy.pl' },
    ],
  },
  {
    title: 'Fundacja Edukacyjna „Perspektywy"',
    external: true,
    links: [
      { label: 'Women in Tech Summit 2019', href: 'http://womenintechsummit.pl' },
      { label: 'Dziewczyny na politechniki!', href: 'http://www.dziewczynynapolitechniki.pl/' },
      { label: 'Study in Poland – serwis dla uczelni', href: 'http://www.info.studyinpoland.pl/' },
      { label: 'Elsevier-Perspektywy Young Researcher Award', href: 'http://www.perspektywy.org/elsevier' },
      { label: 'Interstudent', href: 'http://www.studyinpoland.pl/interstudent' },
      { label: 'Strona Fundacji', href: 'http://www.perspektywy.org/' },
    ],
  },
  {
    title: 'In English',
    external: true,
    links: [
      { label: 'Study in Poland', href: 'http://www.studyinpoland.pl/' },
      { label: 'Study in Warsaw', href: 'http://www.studyinwarsaw.pl/' },
      { label: 'Poland International Education Fair PERSPEKTYWY', href: 'http://www.perspectives.pl/' },
      { label: 'Perspektywy Education Foundation', href: 'http://www.perspektywy.org/' },
      { label: 'IREG Observatory on Academic Ranking', href: 'http://www.ireg-observatory.org/' },
    ],
  },
]

export default function Footer() {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i))

  return (
    <div className="footer pt-2 pt-md-4 pb-1">
      <div className="container">
        <div className="row">
          {sections.map((s, i) => (
            <div className="col-12 col-sm-6 col-md-4" key={s.title}>
              <h4
                className="footer__sliderHead"
                role="button"
                tabIndex={0}
                onClick={() => toggle(i)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    toggle(i)
                  }
                }}
              >
                <i
                  className={`fa-solid fa-caret-right d-md-none${openIndex === i ? ' rotate' : ''}`}
                />
                <span className="pl-2 pl-md-0">{s.title}</span>
              </h4>
              <ul
                className="footer__sliderBody list-unstyled d-md-block"
                style={{
                  display: openIndex === i ? 'block' : undefined,
                }}
              >
                {s.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      {...(s.external
                        ? { target: '_blank', rel: 'noopener noreferrer' }
                        : {})}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}